export var Field;
(function (Field) {
    Field["UNKNOWN"] = "UNKNOWN";
    /** Includes Category url. */
    Field["URL"] = "URL";
    /**
     * Includes internal id field.
     * Reserved for internal use
     */
    Field["INTERNAL_ID"] = "INTERNAL_ID";
    /** Includes SEO data. */
    Field["SEO"] = "SEO";
    /** Includes translations. */
    Field["TRANSLATIONS"] = "TRANSLATIONS";
})(Field || (Field = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map